<div class="container">
  <h2>{{ 'communityList.title' | translate }}</h2>
  <ds-themed-community-list></ds-themed-community-list>
</div>
